import { Button, Menu, MenuItem } from "@mui/material";
import { useState } from "react";

const defaultRenderItems = ({ items, handleClose }) =>
  items.map(({ label, children = label, key = label, ...item }) => (
    <MenuItem
      {...item}
      key={key}
      children={children}
      onClick={() => {
        item.onClick?.();
        handleClose();
      }}
    />
  ));

export const ButtonMenu = ({
  button = { children: "Click me" },
  items = [],
  renderItems = defaultRenderItems,
  hideWhenNoItems = renderItems === defaultRenderItems,
}) => {
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  if (hideWhenNoItems && !items?.length) return null;

  return (
    <div>
      <Button
        id="basic-button"
        aria-controls={open ? "basic-menu" : undefined}
        aria-haspopup="true"
        aria-expanded={open ? "true" : undefined}
        onClick={handleClick}
        {...button}
      />
      <Menu
        id="basic-menu"
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        MenuListProps={{
          "aria-labelledby": "basic-button",
        }}
      >
        {renderItems({ items, handleClose })}
      </Menu>
    </div>
  );
};
